<template>
    <div class="flex">
        <button class="layout-topbar-button text-lg" aria-haspopup="true" aria-controls="i18n_menu" @click="showLanguages">
            {{ currentLanguage.image }}
        </button>
        <Menu ref="menu" :model="AvailableLanguages" :popup="true">
            <template #item="{ item, props }">
                <a v-bind="props.action" @click="changeLocale(item.value)">
                    <span data-pc-section="label">{{ item.name }}</span>
                </a>
            </template>
        </Menu>
    </div>
</template>

<script lang="ts" setup>
    import Menu from 'primevue/menu'
    import { computed, onMounted, useTemplateRef } from 'vue'
    import { useI18n } from 'vue-i18n'

    import { isAuthenticated } from '@/libs/auth.ts'
    import { AvailableLanguages, getLanguage } from '@/libs/language.ts'
    import { useAppStore } from '@/stores/app.ts'
    import { useFetchStore } from '@/stores/fetch.ts'

    // data
    const appStore = useAppStore()
    const fetchStore = useFetchStore()

    const { locale } = useI18n()

    const menu = useTemplateRef<InstanceType<typeof Menu>>('menu')

    // methods
    const showLanguages = (event: Event) => {
        if (menu.value) menu.value.toggle(event)
    }

    const changeLocale = async(newLocale: string) => {
        appStore.changeLocale(newLocale)

        if (isAuthenticated()) await fetchStore.fetch('/update_language').put({ language: newLocale }).json()

        if (menu.value) menu.value.hide()
    }

    // computed
    const currentLanguage = computed(() => {
        return getLanguage(locale.value)
    })

    // hooks
    onMounted(async() => {
        if (!isAuthenticated()) await changeLocale(localStorage.getItem('locale') || 'sl')
    })
</script>
